(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexible-options"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /*
      No JavaScript is required for this section.
      This wrapper is intentionally kept empty for Shopify section isolation.
    */
  })();

  } catch(e) { console.error(e); }
})();
})();
